import * as t from "io-ts";
import {Avatar, CustomTable} from "ui-components";
// import "./styles.css";
import {  TableComponent } from "../../../components";
import { Tooltip } from "@blueprintjs/core";
import { Text } from "ui-components";
import styled from "styled-components";
// import CustomTable from "../../../components/custom-table";

const TableColumnIdIO = t.union([
  t.literal("companyID"),
  t.literal("companyHouseNo"),
  t.literal("companyName"),
  t.literal("url"),
  t.literal("industry"),
  t.literal("sicCode"),
  t.literal("highlights"),
  t.literal("noOfDirectors"),
  t.literal("country"),
]);
type TableColumnIdT = t.TypeOf<typeof TableColumnIdIO>;
export type CompanyT = Record<TableColumnIdT, any>;

const tableColumns: { id: TableColumnIdT; label: string }[] = [
  { id: "companyName", label: "Name" },
  { id: "industry", label: "Industry" },
  { id: "sicCode", label: "Sic Code" },
  { id: "highlights", label: "Company Highlights" },
  { id: "noOfDirectors", label: "Number of Directors" },
  { id: "country", label: "Location" },
  { id: "companyHouseNo", label: "Company House No." },
];

type Props = {
  handleCompanyDetails?: (company: CompanyT) => void;
  companyData?: CompanyT[];
  isStickyFirstColumn?: boolean;
};

const CompanyTableView = (props: Props) => {
  const {  handleCompanyDetails, companyData, isStickyFirstColumn } =
    props;
  const data = companyData || [];
  return (
      <TableComponent mt={2} minHeight="270px">
        <CustomTable>
          <thead>
            <tr>
              {tableColumns.map(({ id, label }) => (
                <th
                  key={id}
                  style={{
                    fontWeight: "bolder",
                    textAlign: "left",
                  }}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.companyID}>
                {tableColumns.map(({ id: columnId }) => (
                  <td
                    key={row.companyID + columnId}
                    onClick={() =>
                      columnId === "companyName" &&
                      handleCompanyDetails &&
                      handleCompanyDetails(row)
                    }
                  >
                    {columnId === "companyName" ? (
                      <span className="display-flex align-center cursor-pointer">
                        <Avatar
                          email={"yantrix@gmail.com"}
                          profileUrl={row?.url?.logo || ""}
                          onlyAvatar={true}
                          displayName={row[columnId]}
                          isCircle={true}
                          isCurrentUser={false}
                          isLoading={false}
                          size="30px"
                        />
                        {row[columnId]}
                      </span>
                    ) : columnId === "highlights" ? (
                      <Tooltip
                        popoverClassName={"w-400"}
                        transitionDuration={1000}
                        placement={"bottom"}
                        content={
													<TooltipContentWrapper>
														{row[columnId]}
													</TooltipContentWrapper>
												}
                      >
                        <Text ellipsis style={{ width: "200px" }}>
                          {row[columnId]}
                        </Text>
                      </Tooltip>
                    ) : (
                      row[columnId]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </CustomTable>
      </TableComponent>
  );
};

export default CompanyTableView;

const TooltipContentWrapper = styled.div`
  white-space: normal;
  overflow-wrap: break-word;
`;
